import { useState, useEffect, useCallback } from 'react';

const WEEK_SHOWN_KEY = 'luma_tour_week_shown';

export function useWeekTour() {
  const [shown, setShown] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(WEEK_SHOWN_KEY);
    setShown(stored === 'true');
    setChecked(true);
  }, []);

  const dismiss = useCallback(() => {
    localStorage.setItem(WEEK_SHOWN_KEY, 'true');
    setShown(true);
  }, []);

  return { showBanner: checked && !shown, dismiss };
}
